module.exports = __webpack_public_path__ + "img/steps4.19fdbe75.png";